import { render, staticRenderFns } from "./ActivityReport.vue?vue&type=template&id=fffafc08&scoped=true"
import script from "./ActivityReport.vue?vue&type=script&lang=js"
export * from "./ActivityReport.vue?vue&type=script&lang=js"
import style0 from "./ActivityReport.vue?vue&type=style&index=0&id=fffafc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffafc08",
  null
  
)

export default component.exports